import { BrowserRouter } from "react-router-dom";
import Route from "./Routes";
import "./assets/scss/themes.scss";

function App() {
  return (
    <>
      <Route />
    </>
  );
}

export default App;
